/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.utilsModule')
.directive('bulbTooltipHelper', ['$document','$compile','$timeout', bulbTooltipHelper]);

function bulbTooltipHelper($document, $compile, $timeout) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {

      var message = attrs.bulbTooltipHelper;
      var inputObj = $(element).find('input').eq(0);

      function showTooltip() {
        $timeout(function() {
          element.trigger('showTooltip');
          scope.$evalAsync(function() {
            var tooltip = element.next('.tooltip');
            if (tooltip.length > 0) {
              tooltip.on('click', hideTooltip);
            }
          });
        });
      }

      function hideTooltip() {
        $timeout(function() {
          element.trigger('hideTooltip');
          scope.$eval(message + '= null');
        });
      }

      /**
       * Automatically display the message tooltip, when there is a message.
       */
      scope.$watch(message, function(message) {
        if (message) {
          showTooltip();
        } else {
          hideTooltip();
        }
      });

      /**
       * Automatically hide the tooltip, when the model changes.
       */
      scope.$watch(function() {
        return inputObj.val();
      }, function() {
        hideTooltip();
      });
    }
  };
}
